<template>
  <div class="flex flex-col gap-3">
    <div
      v-if="isMercadoPago && mercadoPagoConfig"
      class="flex flex-col gap-3 border border-black/10 rounded-xl p-4"
    >
      <p class="text-[1.3rem] text-[color:var(--gray)]">
        {{ $t('Enter your card details in Mercado Pago to finish the reservation.') }}
      </p>
      <MercadoPagoForm
        :key="mercadoPagoConfig.requestId"
        :request-id="mercadoPagoConfig.requestId"
        :amount="mercadoPagoConfig.amount"
        :currency="mercadoPagoConfig.currency"
        :email="mercadoPagoConfig.email"
        :payer="mercadoPagoConfig.payer"
        :public-key="mercadoPagoConfig.publicKey"
        :endpoint="mercadoPagoConfig.endpoint"
        :save-card-token="saveCardToken"
        @success="$emit('mercadopago-success', $event)"
        @error="$emit('mercadopago-error', $event)"
        @loading="$emit('mercadopago-loading', $event)"
      />
    </div>
    <div
      v-if="stripeConfig && isStripeMethod"
      class="flex flex-col gap-3 border border-black/10 rounded-xl p-4"
    >
      <p class="text-[1.3rem] text-[color:var(--gray)]">
        {{ $t('Enter your card details to continue.') }}
      </p>
      <div id="stripe-payment-element"></div>
    </div>
    <div
      v-if="requiresCardForm"
      class="flex flex-col gap-3 border border-black/10 rounded-xl p-4"
    >
      <p class="text-[1.3rem] text-[color:var(--gray)]">
        {{ $t('Enter your card details to continue.') }}
      </p>
      <p
        v-if="requiresNetPay && !netPayAvailable"
        class="text-[1.3rem] text-red-600"
      >
        {{ $t('This payment method is temporarily unavailable. Please try a different one.') }}
      </p>
      <div class="flex flex-col gap-2">
        <label class="flex flex-col gap-1 text-[1.2rem] text-[color:var(--gray)]">
          {{ $t('Card number') }}
          <input
            :value="cardNumber"
            type="text"
            inputmode="numeric"
            autocomplete="cc-number"
            placeholder="1234 5678 9012 3456"
            class="w-full border border-black/10 rounded-xl px-3 py-2 text-[1.4rem] focus:outline-none focus:ring-2 focus:ring-black/40"
            @input="$emit('update:cardNumber', $event.target.value)"
          />
        </label>
        <div class="grid grid-cols-2 gap-3">
          <label class="flex flex-col gap-1 text-[1.2rem] text-[color:var(--gray)]">
            {{ $t('Expiry (MM/YY)') }}
            <input
              :value="cardExpiry"
              type="text"
              inputmode="numeric"
              autocomplete="cc-exp"
              placeholder="MM/YY"
              class="w-full border border-black/10 rounded-xl px-3 py-2 text-[1.4rem] focus:outline-none focus:ring-2 focus:ring-black/40"
              @input="$emit('update:cardExpiry', $event.target.value)"
            />
          </label>
          <label class="flex flex-col gap-1 text-[1.2rem] text-[color:var(--gray)]">
            {{ $t('Security code') }}
            <input
              :value="cardCvv"
              type="text"
              inputmode="numeric"
              autocomplete="cc-csc"
              placeholder="CVV"
              class="w-full border border-black/10 rounded-xl px-3 py-2 text-[1.4rem] focus:outline-none focus:ring-2 focus:ring-black/40"
              @input="$emit('update:cardCvv', $event.target.value)"
            />
          </label>
        </div>
        <label class="flex flex-col gap-1 text-[1.2rem] text-[color:var(--gray)]">
          {{ $t('Cardholder name') }}
          <input
            :value="cardHolder"
            type="text"
            autocomplete="cc-name"
            class="w-full border border-black/10 rounded-xl px-3 py-2 text-[1.4rem] focus:outline-none focus:ring-2 focus:ring-black/40"
            @input="$emit('update:cardHolder', $event.target.value)"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import MercadoPagoForm from '@/components/paymentGateways/mercadopagoForm.vue';

export default {
  name: 'CheckoutPaymentForms',
  components: {
    MercadoPagoForm,
  },
  props: {
    isMercadoPago: {
      type: Boolean,
      default: false,
    },
    mercadoPagoConfig: {
      type: Object,
      default: null,
    },
    saveCardToken: {
      type: Boolean,
      default: false,
    },
    stripeConfig: {
      type: Object,
      default: null,
    },
    isStripeMethod: {
      type: Boolean,
      default: false,
    },
    requiresCardForm: {
      type: Boolean,
      default: false,
    },
    requiresNetPay: {
      type: Boolean,
      default: false,
    },
    netPayAvailable: {
      type: Boolean,
      default: true,
    },
    cardNumber: {
      type: String,
      default: '',
    },
    cardExpiry: {
      type: String,
      default: '',
    },
    cardCvv: {
      type: String,
      default: '',
    },
    cardHolder: {
      type: String,
      default: '',
    },
  },
  emits: [
    'mercadopago-success',
    'mercadopago-error',
    'mercadopago-loading',
    'update:cardNumber',
    'update:cardExpiry',
    'update:cardCvv',
    'update:cardHolder',
  ],
};
</script>
